import * as React from 'react';
import {Redirect, Route} from 'react-router-dom';
// @ts-expect-error
import type {ContextRouter} from 'react-router-dom';

type Props = {
    path: string;
    exact?: boolean;
    hasAccess: boolean;
    redirectPath: string;
    render: (router: ContextRouter) => React.ReactElement;
};

export function RestrictedRoute(props: Props) {
    return (
        <>
            {props.hasAccess ? (
                <Route path={props.path} exact={props.exact} render={props.render} />
            ) : (
                <Redirect to={props.redirectPath} />
            )}
        </>
    );
}
